import { render, staticRenderFns } from "./bulkImportPaper.vue?vue&type=template&id=66b7b6f1"
import script from "./bulkImportPaper.vue?vue&type=script&lang=js"
export * from "./bulkImportPaper.vue?vue&type=script&lang=js"
import style0 from "./bulkImportPaper.vue?vue&type=style&index=0&id=66b7b6f1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports